import SidebarMenuItem from '../classes/definitions/sidebarMenuItem';
import AppRoutes from './appRoutes';
var AppMenus = /** @class */ (function () {
    function AppMenus() {
        this.subMenuItems = {};
        this.subMenuItems[AppRoutes.editOptionType.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'optionValues',
                link: AppRoutes.optionValues.path,
                name: 'Option Values',
            }),
        ];
        this.subMenuItems[AppRoutes.editProduct.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'variants',
                link: AppRoutes.variants.path,
                name: 'Варианти',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'filterOptions',
                link: AppRoutes.filterOptions.path,
                name: 'Филтри',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'reviews',
                link: AppRoutes.reviews.path,
                name: 'Отзиви',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'relatedCollection',
                link: AppRoutes.relatedCollections.path,
                name: 'Свързани продукти',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'additionalImage',
                link: AppRoutes.additionalImage.path,
                name: 'Допълнителна картинка',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'aromaticNotes',
                link: AppRoutes.aromaticNotes.path,
                name: 'Ароматни Нотки',
            }),
        ];
        this.subMenuItems[AppRoutes.editVariant.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'color_images',
                link: AppRoutes.colorImage.path,
                name: 'Цветови картинка',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'variant_images',
                link: AppRoutes.variantImages.path,
                name: 'Картинки',
            }),
        ];
        this.subMenuItems[AppRoutes.editBrand.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'brand_slides',
                link: AppRoutes.brandSlides.path,
                name: 'Слайдове на Марката',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'brand_static_pages',
                link: AppRoutes.staticPages.path,
                name: 'Статични страници',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'brand_categories',
                link: AppRoutes.brandCategories.path,
                name: 'Маркови Категории',
            }),
        ];
        this.subMenuItems[AppRoutes.editStaticPage.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'normal_static_page',
                link: AppRoutes.productLines.path,
                name: 'Линия с продукти',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'static_page_slides',
                link: AppRoutes.staticPageSlides.path,
                name: 'Слайдове на марката',
            }),
        ];
        this.subMenuItems[AppRoutes.editVolumePromotion.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'volume_promotion_levels',
                link: AppRoutes.volumePromotionsLevels.path,
                name: 'Нива',
            }),
        ];
        this.subMenuItems[AppRoutes.editCategory.key] = [
            new SidebarMenuItem({
                exact: false,
                id: "categorySlide",
                link: AppRoutes.categorySlides.path,
                name: "Слайдове на категорията",
            })
        ];
        this.subMenuItems[AppRoutes.editBrand.key] = [
            new SidebarMenuItem({
                exact: false,
                id: 'brand_slides',
                link: AppRoutes.brandSlides.path,
                name: 'Слайдове на Марката',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'brand_static_pages',
                link: AppRoutes.staticPages.path,
                name: 'Статични страници',
            }),
            new SidebarMenuItem({
                exact: false,
                id: 'brand_categories',
                link: AppRoutes.brandCategories.path,
                name: 'Маркови Категории',
            }),
        ];
    }
    AppMenus.menuItems = [
        new SidebarMenuItem({
            exact: true,
            icon: 'fa fa-home',
            id: 'home',
            link: AppRoutes.base.path,
            name: 'Начало',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-bars',
            id: 'signOut',
            link: AppRoutes.orders.path,
            name: 'Поръчки',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-bars',
            id: 'signOut',
            link: AppRoutes.problemOrders.path,
            name: 'Проблемни поръчки',
        }),
        new SidebarMenuItem({
            exact: true,
            icon: 'fa fa-dropbox',
            id: 'home',
            link: AppRoutes.products.path,
            name: 'Продукти',
        }),
        new SidebarMenuItem({
            exact: true,
            icon: 'fa fa-file-image-o',
            id: 'search',
            link: AppRoutes.templates.path,
            name: 'Карета Начало',
        }),
        new SidebarMenuItem({
            exact: true,
            icon: 'fa fa-indent',
            id: 'seo-text',
            link: AppRoutes.seoText.path,
            name: 'SEO Начало',
        }),
        new SidebarMenuItem({
            exact: true,
            icon: 'fa fa-search',
            id: 'search',
            link: AppRoutes.searches.path,
            name: 'Търсене',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-truck',
            id: 'deliveryMethods',
            link: AppRoutes.deliveryMethods.path,
            name: 'Методи на доставка',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-percent',
            id: 'promoCodes',
            link: AppRoutes.promoCodes.path,
            name: 'Промо Код',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-thumbs-up',
            id: 'specialOffers',
            link: AppRoutes.suggestionOffers.path,
            name: 'Нови предложения',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-diamond',
            id: 'specialOffers',
            link: AppRoutes.specialOffers.path,
            name: 'Специални предложения',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-credit-card',
            id: 'paymentMethods',
            link: AppRoutes.paymentMethods.path,
            name: 'Методи на плащане',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-tag',
            id: 'brands',
            link: AppRoutes.brands.path,
            name: 'Брандове',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-tag',
            id: 'optionTypes',
            link: AppRoutes.optionTypes.path,
            name: 'OptionTypes',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-map-marker',
            id: 'regions',
            link: AppRoutes.regions.path,
            name: 'Региони',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-commenting',
            id: 'regions',
            link: AppRoutes.reviews.path,
            name: 'Отзиви',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-users',
            id: 'users',
            link: AppRoutes.users.path,
            name: 'Потребители',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-list-alt',
            id: 'categories',
            link: AppRoutes.categories.path,
            name: 'Категории',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-file-image-o',
            id: 'slides',
            link: AppRoutes.slides.path,
            name: 'Слайдове',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-file-image-o',
            id: 'slides',
            link: AppRoutes.promoSlides.path,
            name: 'Промо Слайдове',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-file-image-o',
            id: 'volumePromotions',
            link: AppRoutes.volumePromotions.path,
            name: 'Количествени промоции',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-smile-o',
            id: 'samples',
            link: AppRoutes.samples.path,
            name: 'Сампли',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-file-o',
            id: 'refreshs',
            link: AppRoutes.refreshs.path,
            name: 'Обнови цени',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-map-marker',
            id: 'prices',
            link: AppRoutes.prices.path,
            name: 'График цени',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-smile-o',
            id: 'gifts',
            link: AppRoutes.gifts.path,
            name: 'Подаръци',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-picture-o',
            id: 'static_images',
            link: AppRoutes.staticImages.path,
            name: 'Статични картинки',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-signal',
            id: 'static_images',
            link: AppRoutes.adjustmentLevels.path,
            name: 'Нива на отстъпки',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-file-o',
            id: 'static_pages',
            link: AppRoutes.staticPages.path,
            name: 'Статични страници',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-fire',
            id: 'rituals',
            link: AppRoutes.rituals.path,
            name: 'Ритуали',
        }),
        new SidebarMenuItem({
            exact: false,
            icon: 'fa fa-sign-out',
            id: 'signOut',
            link: AppRoutes.login.path,
            name: 'Изход',
        }),
    ];
    return AppMenus;
}());
export default AppMenus;



//////////////////
// WEBPACK FOOTER
// ./src/config/appMenus.ts
// module id = 21
// module chunks = 0